import React, { FunctionComponent } from 'react'
import { DatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import type { Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

interface IProps {
  dateRange: [start: Dayjs | null | undefined, end: Dayjs | null | undefined]
  setDateRange: (range: [start: Dayjs | null | undefined, end: Dayjs | null | undefined]) => void
  minDate: Dayjs
  maxDate: Dayjs
}

const getYearMonth = (date: Dayjs) => date.year() * 12 + date.month()

const DateRangePicker: FunctionComponent<any> = (props: IProps) => {
  const { dateRange, setDateRange, minDate, maxDate } = props

  // Disabled 7 days from the selected date
  const disabled7DaysDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
    if (from) {
      const minDate = from.add(-6, 'days')
      const maxDate = from.add(6, 'days')

      switch (type) {
        case 'year':
          return current.year() < minDate.year() || current.year() > maxDate.year()

        case 'month':
          return (
            getYearMonth(current) < getYearMonth(minDate) || getYearMonth(current) > getYearMonth(maxDate)
          )

        default:
          return Math.abs(current.diff(from, 'days')) >= 7
      }
    }

    return false
  }

  const onChange = (e: any) => {
    if (e === null) {
      setDateRange([undefined, undefined])
    } else {
      setDateRange(e)
    }
  }

  return (
    <RangePicker
      style={{ width: '100%' }}
      minDate={minDate}
      maxDate={maxDate}
      defaultValue={dateRange}
      disabledDate={disabled7DaysDate}
      onChange={onChange}
    />
  )
}

export default DateRangePicker
